import { render, staticRenderFns } from "./comDetails.vue?vue&type=template&id=dc101842&scoped=true&"
import script from "./comDetails.vue?vue&type=script&lang=ts&"
export * from "./comDetails.vue?vue&type=script&lang=ts&"
import style0 from "./comDetails.vue?vue&type=style&index=0&id=dc101842&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc101842",
  null
  
)

export default component.exports